import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";

@Pipe({
	name: 'translateOptionWithPrefix'
})

/**
 * A custom Angular pipe that transforms a given ID into a translated string
 * using a specified translation prefix. If the translation is not found,
 * it returns a provided default value.
 *
 * @param id - The identifier for the translation key.
 * @param translationPrefix - The prefix to prepend to the ID for translation lookup.
 * @param defaultValue - The default value to return if no translation is found.
 * @returns The translated string or the default value if translation is unavailable.
 */
export class TranslateOptionWithPrefixPipe implements PipeTransform
{

	constructor(private translate: TranslateService)
	{
	}
	transform(id: string, translationPrefix: string, defaultValue: string)
	{
		const key: string = `${translationPrefix}_${id.toUpperCase()}`;
		const translatedValue: string = this.translate.instant(key);

		if (translatedValue !== key)
		{ 
			//If exists use it
			return translatedValue;
		} 
		else
		{
			console.debug("No translation found for: ", key);
			return defaultValue;
		}
	}

}
